import React from "react";
import "./EscalationBanner.css";

/**
 * EscalationBanner
 * Shows a banner listing conversations that have been escalated
 * (e.g. bot could not resolve, visitor requested a human, SLA breach).
 *
 * Props:
 *  - escalations: [{ id, visitorName, reason, waitMinutes }]
 *  - tone: "danger" | "warning"  (visual urgency)
 *  - onView(id)      -> jump to that conversation
 *  - onDismiss(id)   -> remove a single escalation from the banner
 */
export default function EscalationBanner({
  escalations = [],
  tone = "danger",
  onView = () => {},
  onDismiss = () => {},
}) {
  if (!escalations.length) return null;

  return (
    <div
      className={`cb-escalation-banner ${tone === "warning" ? "cb-warning-tone" : ""}`}
      role="alert"
    >
      <div className="cb-escalation-icon">!</div>
      <div className="cb-escalation-body">
        <div className="cb-escalation-title">
          {escalations.length} conversation{escalations.length > 1 ? "s" : ""} need
          {escalations.length > 1 ? "" : "s"} human attention
        </div>

        <div className="cb-escalation-list">
          {escalations.map((esc) => (
            <div className="cb-escalation-item" key={esc.id}>
              <div>
                <strong>{esc.visitorName}</strong> — {esc.reason}
                <span className="cb-wait"> &nbsp;({esc.waitMinutes}m waiting)</span>
                {esc.overdue && <span className="cb-overdue">Over alert time</span>}
              </div>
              <div className="cb-escalation-actions">
                <button
                  className="cb-claim-btn"
                  style={{ padding: "4px 10px" }}
                  onClick={() => onView(esc.id)}
                >
                  View
                </button>
                <button
                  className="cb-escalation-dismiss"
                  aria-label="Dismiss"
                  onClick={() => onDismiss(esc.id)}
                >
                  ×
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
